import React, {useState} from "react";
import { Button, Card, Alert } from "react-bootstrap";
import { useAuth } from 'contexts/authContext'
import { Link , useHistory  } from 'react-router-dom'
import Background from 'assets/img/wal.jpg';

import {
    Container,
    Col,
    } from "react-bootstrap";

function HomeS(){

    const [error,setError] = useState("")
    const {currentUser , logout} = useAuth()
    const history = useHistory()

    async function handleLogout(){ 

        setError('')

        try{
            await logout()
            history.pushState('/login')

        }catch{
            setError('failed to logout')
        }
    }

    var sectionStyle = {
        // width: "100%",
        // height: "100%",
        backgroundSize: 'cover', 
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${Background } )` 
      };


    return(
    <>
    <section style={ sectionStyle }>
    <center>
    <Container>
    <br>
    </br>
    <h2 className="text-center mb-4">SuperAdmin Profile</h2>
    <Col md="5">
    <Card className="card-user">
    <div className="card-image">
    <img
    alt="..."
    src={
    require("assets/img/photo-1431578500526-4d9613015464.jpeg")
    .default
    }
    ></img>
    
    </div>
    <Card.Body>
    <div className="author">
    <a href="#pablo" onClick={(e) => e.preventDefault()}>
    <img
    alt="..."
    className="avatar border-gray"
    src={require("assets/img/faces/face-3.jpg").default}
    ></img>
    <h5 className="title"><strong>Email: </strong> {currentUser.email}</h5>
    </a>
    </div>
    <p className="description text-center">
    The Super Admin user is the person who looks after all network management,<br></br>
    A super admin user has the ability to: Manage the access and level of responsibility of all users on all sites on your network.<br></br>
    Create new users and Transport managers. Edit posts, pages, on any site without being added as a user to the site.
    </p>
    </Card.Body>
    <hr></hr>
    <div className="button-container mr-auto ml-auto">
    <Button
    className="btn-simple btn-icon"
    href="#pablo"
    onClick={(e) => e.preventDefault()}
    variant="link"
    >
    <i className="fab fa-facebook-square"></i>
    </Button>
    <Button
    className="btn-simple btn-icon"
    href="#pablo"
    onClick={(e) => e.preventDefault()}
    variant="link"
    >
    <i className="fab fa-twitter"></i>
    </Button>
    <Button
    className="btn-simple btn-icon"
    href="#pablo"
    onClick={(e) => e.preventDefault()}
    variant="link"
    >
    <i className="fab fa-google-plus-square"></i>
    </Button>
    {error && <Alert variant="danger">{error}</Alert>}
        <Link to="/dashboard" className="btn btn-primary w-100 mt-3">
            Go to Dashboard
          </Link>
        <div>
        <Button className="btn btn-primary w-100 mt-3" variant="danger" onClick={handleLogout}> Logout </Button>
        </div>
        <br>
    </br>
    </div>
    </Card>
    </Col>
    </Container>
    </center>
    <br>
    </br>
    <br>
    </br>
    </section>
    </>
    )
}
export default HomeS


